import { Injectable } from '@angular/core';
import { Router, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApplicationActions } from '../actions/application.actions';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class ValidationCanDeactivate implements CanDeactivate {
  constructor(
    appActions: ApplicationActions,
    flowManager: FlowManagerService,
    router: Router) {
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.router = router;
  }

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.flowManager.submitError === false) {
      window.history.forward();
      window.history.pushState({}, 'Forward');
      window.scrollTo(0, 0);
    }
    return !this.flowManager.submitError;
  }
}
